// OAuth scopes requested on the FIRST-leg auth request that the sign-in website makes to the
// session-IdP / login-website app client. These are hardcoded (not sourced from the customer's
// request) because the tokens minted on this leg are used by the sign-in website to invoke
// Supergraph, which expects the sb/all scope on the access token to resolve the application
// authorization profile. The customer-provided scopes are a separate concern: they are forwarded
// verbatim on the SECOND-leg redirect to the destination (redirect_uri) and are not affected here.

// The OpenID Connect scope. Always required on the login-client auth request so Cognito issues an
// ID token for the sign-in flow.
export const OPENID_SCOPE = 'openid';

// The Skill Builder scope. Granted on the login-client tokens so the sign-in website's downstream
// Supergraph calls carry the application authorization profile Supergraph enforces against.
export const SB_ALL_SCOPE = 'sb/all';
